/**
 * Axios interceptors {@link https://github.com/axios/axios#interceptors}
 */
import axios from 'axios'
import authenticationService from '@/services/authenticationService'

class ErrorHandlingInterceptor {
  responseSuccessInterceptor = (response) => {
    if (response.data != null && response.data.Errors && response.data.Errors.Messages?.length) {
      const warnings = response.Errors.Messages

      warnings.forEach((warning) => {
        window.VUE_CLI_EXPORTS.plugins.EventBus.$emit('notification-warning', warning)
      })
    }
    return response
  }

  responseErrorInterceptor = (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }

    // Check for both Messages (capital) and messages (lowercase)
    const messages = error.response?.data?.Messages || error.response?.data?.messages

    if (messages && Array.isArray(messages)) {
      messages.forEach((msg) => {
        // Handle both string messages and message objects
        const messageText = typeof msg === 'string' ? msg : msg.message || msg.Message
        if (messageText) {
          window.VUE_CLI_EXPORTS.plugins.EventBus.$emit('notification-warning', messageText)
        }
      })
    }

    // Every axios instance in the app runs this, so a network error, a timeout, a
    // DNS failure or a CORS rejection lands here with no `response` at all. Reading
    // `.status` off it threw a TypeError inside the interceptor, which replaced the
    // real error before any caller's catch could see it.
    if (error.response?.status === 401) {
      //check that user is still logged in
      authenticationService.setCurrentUser()
    }

    return Promise.reject(error)
  }

  // New interceptor that suppresses all notifications (for use when handling errors manually)
  suppressAllNotificationsInterceptor = (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }

    if (error.response?.status === 401) {
      //check that user is still logged in
      authenticationService.setCurrentUser()
    }

    return Promise.reject(error)
  }

  errorHandlingInterceptor = (instance) => {
    instance.interceptors.response.use(
      this.responseSuccessInterceptor,
      this.responseErrorInterceptor
    )
  }
}

export default new ErrorHandlingInterceptor()
